import { MutationTree } from 'vuex';
import { IRootState } from './store';

export const mutationSetIds = 'setIds';
export const mutationSetPreviewMode = 'setPreviewMode';
export const mutationSetPreviewExpired = 'setPreviewExpired';

export const mutations: MutationTree<IRootState> = {
  [mutationSetIds](
    state: IRootState,
    {
      documentId,
      recipientId,
      authId,
      userId,
      videoReminderId,
    }: {
      documentId: string;
      recipientId?: string;
      authId: string;
      userId?: string;
      videoReminderId?: string;
    }
  ) {
    state.documentId = documentId;
    state.recipientId = recipientId;
    state.authId = authId;
    state.userId = userId;
    state.videoReminderId = videoReminderId;
  },
  [mutationSetPreviewMode](state: IRootState, isPreview: boolean) {
    state.isPreview = isPreview;
  },
  [mutationSetPreviewExpired](state: IRootState, expired: boolean) {
    state.previewExpired = expired;
  },
};
